import { Box, Button, Card, CardHeader, Typography } from '@mui/material';
import React from 'react';
import {
  Datagrid,
  List,
  Pagination,
  TextField,
  useTranslate,
} from 'react-admin';
import { Link } from 'react-router-dom';
import { ActionMenu } from '../../components/ActionMenu';
import { LeadersAvatar } from '../../components/LeadersAvatar';
import { MembersList } from '../members/MembersList';

const CustomPagination = props => (
  <Pagination rowsPerPageOptions={[8, 16, 24]} {...props} />
);

export const TeamList = () => {
  const t = useTranslate();
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          padding: '20px 0 10px 0',
        }}
      >
        <Typography
          variant="h1"
          sx={{
            textAlign: 'center',
            fontSize: '32px',
            fontWeight: '700',
          }}
        >
          {t('resources.teams.title')}
        </Typography>
      </Box>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          padding: '24px',
          borderRadius: '20px',
        }}
        elevation={0}
      >
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingBottom: '10px',
            }}
          >
            <CardHeader
              title={t('resources.teams.title')}
              sx={{
                padding: '0',
              }}
            />
            <Button variant="contained" component={Link} to="/teams/create">
              {t('resources.teams.create.title')}
            </Button>
          </Box>
          <List
            title={' '}
            perPage={8}
            actions={false}
            sort={{ field: 'name', order: 'DESC' }}
            sx={{
              border: 'none',
              '&:last-child th:last-of-type': { width: '40px' },
            }}
            resource="teams"
            storeKey="teams"
            pagination={
              <CustomPagination sort={{ field: 'name', order: 'DESC' }} />
            }
            disableSyncWithLocation
          >
            <Datagrid bulkActionButtons={false} rowClick="edit">
              <TextField source="name" label="Equipo" />
              <LeadersAvatar source="leaders" label="Líderes" />
              <TextField source="members_count" label="Redactores" />
              <ActionMenu resource="teams" />
            </Datagrid>
          </List>
        </>
      </Card>
      <MembersList />
    </>
  );
};
